export const existRender = (row) => {
  if (row.inStockAll) {
    if (row.inStockAll === row.inStock) {
      return row.inStock;
    }
    return `${row.inStock || 0} (${row.inStockAll})`;
  }
  return row.inStock;
};